var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
export const useWrapAsync = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const wrapAsync = (fn) => (...args) => __awaiter(void 0, void 0, void 0, function* () {
        let success = true;
        try {
            setError(undefined);
            setLoading(true);
            yield fn(...args);
        }
        catch (e) {
            success = false;
            setError(new Error(e.message));
        }
        setLoading(false);
        return success;
    });
    return {
        loading,
        error,
        wrapAsync,
        resetAsync: () => {
            setLoading(false);
            setError(undefined);
        },
    };
};
//# sourceMappingURL=wrap-async.js.map